export default "ax=ah\nbr=\ncl=\ndr=jh r\ndx=d\npau=\nsil=\ntr=ch r\n";